import { HOME_SLIDER } from "../../constants/actionTypes";
import axios from 'axios';

export const addHomeSlider = (token, data) => {
    return (dispatch) => {
        dispatch({ type: HOME_SLIDER.ADD_HOME_SLIDER_REQUEST });
        const AuthStr = 'Bearer '.concat(token);
        const INSTANCE = axios.create({
            headers: {
                'Content-Type': 'application/json',
                'Authorization': AuthStr
            }
        });

        let inputJSON = JSON.stringify(data);
        
        INSTANCE.post("home-slider/create", inputJSON)
            .then(function (response) {
                dispatch(addHomeSliderSuccess(response.data));
            })
            .catch(function (error) {
                dispatch(addHomeSliderError(error.message));
            });
    };
};

const addHomeSliderSuccess = (data) => ({
    type: HOME_SLIDER.ADD_HOME_SLIDER_SUCCESS,
    payload: data
});

const addHomeSliderError = errorMessage => ({
    type: HOME_SLIDER.ADD_HOME_SLIDER_FAIL,
    payload: errorMessage
});

export const listHomeSlider = (token, data) => {
  return (dispatch) => {
    dispatch({ type: HOME_SLIDER.LIST_HOME_SLIDER_REQUEST });
    const AuthStr = 'Bearer '.concat(token);
    let inputJSON = JSON.stringify(data);
    const INSTANCE = axios.create({
      headers: {
        'Content-Type': 'application/json',
        'Authorization': AuthStr
      }
    });

    INSTANCE.post("home-slider/lists", inputJSON)
      .then(function (response) {
        dispatch(listHomeSliderSuccess(response.data));
      })
      .catch(function (error) {
        dispatch(listHomeSliderError(error.message));
      });
  };
};

const listHomeSliderSuccess = (data) => ({
    type: HOME_SLIDER.LIST_HOME_SLIDER_SUCCESS,
    payload: data
});

const listHomeSliderError = errorMessage => ({
    type: HOME_SLIDER.LIST_HOME_SLIDER_FAIL,
    payload: errorMessage
});

export const deleteHomeSlider = (token, data) => {
    return (dispatch) => {
        dispatch({ type: HOME_SLIDER.DELETE_HOME_SLIDER_REQUEST });
        const AuthStr = 'Bearer '.concat(token);
        const INSTANCE = axios.create({
            headers: {
                'Content-Type': 'application/json',
                'Authorization': AuthStr
            }
        });

        let inputJSON = JSON.stringify(data);
        
        INSTANCE.post("home-slider/delete", inputJSON)
            .then(function (response) {
                dispatch(deleteHomeSliderSuccess(response.data));
            })
            .catch(function (error) {
                dispatch(deleteHomeSliderError(error.message));
            });
    };
};

const deleteHomeSliderSuccess = (data) => ({
    type: HOME_SLIDER.DELETE_HOME_SLIDER_SUCCESS,
    payload: data
});

const deleteHomeSliderError = errorMessage => ({
    type: HOME_SLIDER.DELETE_HOME_SLIDER_FAIL,
    payload: errorMessage
});

export const updateHomeSlider = (token, data) => {
    return (dispatch) => {
        dispatch({ type: HOME_SLIDER.UPDATE_HOME_SLIDER_REQUEST });
        const AuthStr = 'Bearer '.concat(token);
        const INSTANCE = axios.create({
            headers: {
                'Content-Type': 'application/json',
                'Authorization': AuthStr
            }
        });

        let inputJSON = JSON.stringify(data);
        
        INSTANCE.post("home-slider/update", inputJSON)
            .then(function (response) {
                dispatch(updateHomeSliderSuccess(response.data));
            })
            .catch(function (error) {
                dispatch(updateHomeSliderError(error.message));
            });
    };
};

const updateHomeSliderSuccess = (data) => ({
    type: HOME_SLIDER.UPDATE_HOME_SLIDER_SUCCESS,
    payload: data
});

const updateHomeSliderError = errorMessage => ({
    type: HOME_SLIDER.UPDATE_HOME_SLIDER_FAIL,
    payload: errorMessage
});

export const resetHomeSlider = () => {
    return (dispatch) => {
        dispatch({ type: HOME_SLIDER.RESET_HOME_SLIDER})
    }
}
